module.exports = __webpack_public_path__ + "28b67065/img/mini-logo.18817ee5.svg";